function menuGroup(){
$('html').click(function() {
  if ($(".menu-trigger").hasClass("active")){
    $(".menu-trigger").removeClass("active");
  }
  if ($(".menu-dropdown").hasClass("open")){
    $(".menu-dropdown").removeClass("open").addClass("closed");
  }
});
// Open menu
$(".menu-trigger").click(function(event) {
  event.preventDefault();
  event.stopPropagation();
  $(this).toggleClass("active");
  if($(this).next('.menu-dropdown').hasClass("closed")){
    $(this).next(".menu-dropdown").removeClass("closed").addClass("open");
  }
});
}
menuGroup();


$('#resetOrder').click( function (e) {
  $('#crypto-table').DataTable().colReorder.order( [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ], true );
  $('#crypto-table').DataTable().columns(':not(.initial)').visible(false);
  $('#crypto-table').DataTable().columns('.initial').visible(true);
  reorderColBtn();
  // runsticky();
} );


$('#layoutClassic').click( function (e) {
  $('#crypto-table').DataTable().colReorder.order( [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ], true );
  $('#crypto-table').DataTable().columns(':not(.initial)').visible(false);
  $('#crypto-table').DataTable().columns('.initial').visible(true);
  reorderColBtn();
  // runsticky();
} );



$('#layoutIndicators').click( function (e) {
  $('#crypto-table').DataTable().colReorder.order( [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ], true );
  $('#crypto-table').DataTable().columns(':not(.indicator)').visible(false);
  $('#crypto-table').DataTable().columns('.indicator').visible(true);
  reorderColBtn();
  // runsticky();
} );

$('#layoutDeltas').click( function (e) {
  $('#crypto-table').DataTable().colReorder.order( [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ], true );
  $('#crypto-table').DataTable().columns(':not(.delta)').visible(false);
  $('#crypto-table').DataTable().columns('.delta').visible(true);
  reorderColBtn();
  // runsticky();
} );

$('#layoutAll').click( function (e) {
  $('#crypto-table').DataTable().colReorder.order( [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ], true );
  // $('#crypto-table').DataTable().columns(':not(.hodler)').visible(false);
  $('#crypto-table').DataTable().columns('').visible(true);
  reorderColBtn();
  // runsticky();
} );



$('#set-settings').on('click', function(e) {
  e.preventDefault();
  reorderColBtn();
  $('.modal.msettings').addClass('is-visible');
  $(".dt-button.disabled span").on('click', function(e) {
      $('#visibilityLabel').css('color', '#f44336');
      setTimeout(function(){  $('#visibilityLabel').css('color', 'inherit'); }, 1000);
  });
});


$('.modal-close').on('click', function(e) {
  e.preventDefault();
  $('.modal').removeClass('is-visible');
});


function reorderColBtn() {
  // $("button.dt-button:contains(20d SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(20w SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(50d SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(50w SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(100d SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(100w SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(200d SMA)").detach().appendTo('#smaBtn');
  // $("button.dt-button:contains(200w SMA)").detach().appendTo('#smaBtn');


  $("button.dt-button:contains(RSI)").detach().appendTo('#smaBtn');
  $("button.dt-button:contains(BB:)").detach().appendTo('#smaBtn');
  $("button.dt-button:contains(MACD)").detach().appendTo('#smaBtn');



  $("button.dt-button:contains(1h)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(24h)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(7d)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(14d)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(30d)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(90d)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(200d)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(1y)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(2y)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(3y)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(4y)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(5y)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(Age)").detach().appendTo('#roiBtn');
  $("button.dt-button:contains(Alter)").detach().appendTo('#roiBtn');
  // $("button.dt-button:contains(USD)").detach().appendTo('#riskBtn');
  // $("button.dt-button:contains(BTC)").detach().appendTo('#riskBtn');
  // $("button.dt-button:contains(ETH)").detach().appendTo('#riskBtn');
  $("button.dt-button:contains(Price)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Preis)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Prix)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Ath)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Market Cap)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Marktkapitalisierung)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Cap. Marché)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Supply)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Umlaufversorgung)").detach().appendTo('#othBtn');
  $("button.dt-button:contains(Offre)").detach().appendTo('#othBtn');


};
